// extracted by mini-css-extract-plugin
module.exports = {"projectViewer":"ProjectViewerModal_projectViewer__358zN","closeIcon":"ProjectViewerModal_closeIcon__3BESq","content":"ProjectViewerModal_content__3vZ1U"};